import React from 'react';
import { 
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    SearchInput,
    EditButton,
    ShowButton,
    BooleanField,
    SimpleShowLayout,
    Show,
    Edit,
    SimpleForm,
    CheckboxGroupInput

} from 'react-admin';
import BoolNumField from '../controls/BoolNumField'
import withStyles from '@material-ui/core/styles/withStyles';
import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();

const styles = {
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
};


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};


export const SetTrainingFilters = props => (
    <Filter {...props}>
        <SearchInput source="training_name" alwaysOn  placeholder='Training Name'/>
        <TextInput source="frequency" lable="Frequency" />  
    </Filter>
);



const Questions =({record})=>{
  console.log(record)
  var questions  = [];
  if(record && record.question){
    try{
      questions =JSON.parse(record.question) 
    } catch(e) {
      //console.log(e)
      questions = record.question;
    };
  }
  console.log(questions)
  
  return(
    <div>
        <h4>Exam Questions:</h4>
    {questions && questions.map((item, index) =>(
          
          <p key={index}><font color="navy" size="2">
          <span>{htmlToReactParser.parse(item['passage'])}</span>
          &nbsp;{index+1}).&nbsp;
          {item['quest']}<br/></font>
          {item['Choices'] && item['Choices'].map((ans, i)=><span  key={i+500}>&nbsp;&nbsp;&nbsp;&nbsp;<font color={ans && ans['isAnswere']? "green" : "grey"} size="2">{i + 1}. {ans && ans['answer']}<br/></font></span>)}
        </p>
    ))
    }
   </div>
  )
  }

const PostShow = props => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout>
            <TextField source="code" label="Code" />
            <TextField source="description" label="Description" />
            <TextField source="frequency_desc" label="Frequency" />
            <Questions />
            <TextField source="passing_percentage" label="Passing Percentage" />
            <TextField source="roles_desc"  lablel='Role(s)'/>
            <TextField source="comments" label="Comments" />
            <BooleanField source='isactive' lablel="Is Active?" />
        </SimpleShowLayout>
    </Show>
);


export const SetTrainingList =  ({ classes, permissions, ...props }) => (
    <List 
        {...props}
        filters={<SetTrainingFilters />}
        perPage={20}
        sort={{ field: 'training_name', order: 'ASC' }}
        bulkActionButtons ={false}
        title= "Training Name"
        >
        <Datagrid  classes={{ headerCell: classes.header }} expand={<PostShow />}  >               
            <TextField source="training_name" label="Name" />
            <TextField source="frequency_desc" lable="Frequency" />  
            <TextField source="roles_desc" lable="Role(s)" />  
            <BoolNumField  source="isactive" label="Is Active?" />
        </Datagrid>
    </List>
);


export default withStyles(listStyles)(SetTrainingList)